import { $api } from '../../global';

export const getUniversitySort = (univerId?: string | string[]) => async () => {
  const { data } = await $api.get('/university-sort-column', {
    params: { univer_id: univerId }
  });

  return data;
};
